import { swRequest } from "@sourcewhale/core";

export const getAlerts = () =>
  swRequest({
    path: "/api/users/get_alerts",
  });
